import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { EcoEnelEmpresasPage } from "./ecoenel-empresas";
import { EcoEnelEmpresasProvider } from "../../providers/ecoenel-empresas/ecoenel-empresas.provider";
import { ReciclagemCriarPage } from "./reciclagem-criar/reciclagem-criar";
import { ReciclagemDetalhePage } from "./reciclagem-detalhe/reciclagem-detalhe";
import { ReciclagemResponderPage } from "./reciclagem-responder/reciclagem-responder";

@NgModule({
  declarations: [
    EcoEnelEmpresasPage,
    ReciclagemCriarPage,
    ReciclagemDetalhePage,
    ReciclagemResponderPage,
  ],
  imports: [
    IonicPageModule.forChild(EcoEnelEmpresasPage),
  ],
  entryComponents: [
    ReciclagemCriarPage,
    ReciclagemDetalhePage,
    ReciclagemResponderPage,
  ],
  providers: [EcoEnelEmpresasProvider],
})
export class EcoEnelEmpresasPageModule {}



// WEBPACK FOOTER //
// ./src/pages/ecoenel-empresas/ecoenel-empresas.module.ts